<template>
  <div>
    <!-- dialog -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="importDialog"
      :title="dialogTitle"
      width="75%"
      @close="clearImportData"
      @opened="opened"
    >
      <el-row class="import-table">
        <ImportData
          ref="import"
          importName="file"
          :excelName="excelName"
          :tableData="importTable"
          :uploadUrl="uploadUrl"
          :uploadBtnDisabled="importSelection.length === 0"
          @submit="sumbitTableData"
          @beginUpload="beginUpload"
          @returnData="returnData"
        >
          <el-button size="mini" @click="downloadFile">下载模板</el-button>
        </ImportData>
      </el-row>
      <wxe-table
        ref="wxeTable"
        :title="title"
        :importRowErrMsg="'errorMsg'"
        :tableData="importTable"
        :tableHead="tableColumns"
        :loading="loading"
        @wxe-table-select="importTableChange"
      />
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="mini"
          @click="importDialog=false"
          >取消</el-button
        >
      </span>
    </el-dialog>

    <!-- 批量操作后的弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      :show-close="false"
      :visible.sync="resultDialogVisible"
    >
      <ResultDialog
        :dialogResult="dialogResult"
        :tableDataField="'failResultList'"
        tableLable="产品名称"
      />
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="resultDialogVisible = false"
          size="mini"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import ImportData from '@/components/ImportData';
import WxeTable from '@/components/ImportData/WxeTable';
import ResultDialog from '@/components/ResultDialog';
import download from '@/utils/download';
import sampleImportMixin from '@/mixins/samplerImportMixin';
import { groupBy, toPairs } from 'lodash';

export default {
  components: { ImportData, WxeTable, ResultDialog },
  mixins: [sampleImportMixin],
  data() {
    return {
      uploadUrl:
        process.env.VUE_APP_CML_BASE_URL +
        'giftMaterialSample/batchImportPreview',  // 上传地址
      tableColumns: [
        { prop: 'errorMsg', label: '提示' },
        { prop: 'productName', label: '产品名称' },
        { prop: 'productTypeName', label: '产品类别' },
        { prop: 'productCategoryName', label: '产品品类' },
        { prop: 'material', label: '材质' },
        { prop: 'size', label: '尺寸' },
        { prop: 'craft', label: '工艺' },
        { prop: 'havePatentName', label: '是否有专利' },
        { prop: 'proofingTime', label: '样品的打样时间（天）' },
        { prop: 'deliveryTime', label: '样品的大货时间（天）' },
        { prop: 'minNum', label: '正式订单的最低起订量(个)' },
        { prop: 'price', label: '预估含税价(元/个)' }, 
        { prop: 'haveMassProductionName', label: '是否为我司生产过此样品的大货' },
        { prop: 'brandsUsed', label: '已使用品牌' },
        { prop: 'developmentProgress', label: '开发进度' },
      ],
      excelName: '赠品样品导入模板.xlsx',
      dialogResult: {},
      resultDialogVisible: false,
      importSelection: []
    };
  },
  props: {
    importParams: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  watch: {
    importTable(val) {
      if (val.length === 0) this.$refs.import.fileList = [];
    },
  },
  mounted() {
    const { category, customerId } = this.$store.getters.userSupplier;
    this.category = [category];
    this.customerId = customerId;
  },
  methods: {
    // 确认上传
    batchImport() {
      const parmas = this.combinationData();
      this.$http.sampleManage
        .batchImportGiftSample(parmas)
        .then(result => {
          if (result.data.failNum === 0) {
            this.$message.success(result.msg);
          } else {
            this.dialogResult = result.data;
            this.resultDialogVisible = true;
          }
          this.refreshData();
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.$refs.import.loading = false;
        });
    },
    // 下载模板文件
    downloadFile() {
      download(
        process.env.VUE_APP_CML_BASE_URL + 'giftMaterialSample/downloadFile',
        this.excelName,
      );
    },
    combinationData() {
      // 供应商样品分组
      const allGroupedItems = toPairs(
        groupBy(this.importSelection, 'supplierCode'),
      ).map(item => {
        return {
          supplierCode: item[0],
          arr: toPairs(groupBy(item[1], 'productName')),
        };
      });
      // 获取第一个供应商样品分类
      const groupedItems = allGroupedItems[0].arr.map(o => o[1]);
      // 组合样品数据
      const combinationData = groupedItems.map(items => {
        return {
          ...items[0],
        };
      });
      return combinationData;
    }
  },
};
</script>

<style lang="less" scoped>
.import-table {
  display: flex;
  align-items: center;
  margin-top: -20px;
  margin-bottom: 10px;
  border-bottom: 1px solid #ccc;
}
.el-link {
  display: block;
  margin: 15px;
}
</style>
